import { GetFrontTipiDomandaStato } from '@framework/api-client/api/inquiries-compile/schemas/getFrontTipiDomandaStato.ts';
import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IInquiryStateSelectInputProps extends ISelectInputProps {}

/**
 * Select per lo stato della domanda
 */
export function InquiryStateSelectInput(props: IInquiryStateSelectInputProps) {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return [
      {
        value: GetFrontTipiDomandaStato.PUBBLICATA,
        label: t('inquiry.stato.pubblicata', 'Pubblicata'),
      },
      {
        value: GetFrontTipiDomandaStato.APERTA,
        label: t('inquiry.stato.aperta', 'Aperta'),
      },
      {
        value: GetFrontTipiDomandaStato.IN_CORSO,
        label: t('inquiry.stato.in_corso', 'In corso'),
      },
      {
        value: GetFrontTipiDomandaStato.CHIUSA,
        label: t('inquiry.stato.chiusa', 'Chiusa'),
      },
    ];
  }, [t]);

  return (
    <SelectInput
      {...props}
      name="stato"
      allowClear
      optionFilterProp="label"
      style={{ width: '100%' }}
      options={options}
    />
  );
}
